export default {
  inspirations: 'Inspiración',
  gifts: 'Regalos',
  occasions: 'Ocasiones',
  'tutorials-and-advices': 'Tutoriales y consejos',
  'home-furnishing': 'Decoración de casa',
  highlights: 'Highlights',
}
